import { inject, Injectable } from '@angular/core';
import { MojoEditorService } from 'mojo-editor/lib/mojo-editor.config';
import { map, Observable, of } from 'rxjs';
import { UserService } from './user.service';
import { User } from '../models/user';

@Injectable({ providedIn: 'root' })
export class EditorService implements MojoEditorService {
  userService = inject(UserService);

  candidateAutocomplete() {
    return of([]);
  }

  /* eslint-disable @typescript-eslint/no-explicit-any */
  searchJobsForMentions(): Observable<any[]> {
    return of([]);
  }

  /* eslint-disable @typescript-eslint/no-explicit-any */
  talentPoolAutocomplete(): Observable<any[]> {
    return of([]);
  }

  usersSearch(apiParams: any): Observable<any> {
    return this.userService.get({ params: apiParams }).pipe(map((page) => page?.content));
  }

  getUsersList(usersIds: number[]): Observable<User[]> {
    return this.userService.getUsersByIds(usersIds);
  }
}
